
export default function HeroSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="\images\heroimage.jfif"
          alt="Master Mystique"
          className="w-full h-full object-cover object-top"
          style={{ minHeight: '100vh' }}
          onLoad={() => console.log('Image loaded successfully')}
          onError={() => console.log('Image failed to load')}
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 flex justify-end">
        <div className="text-right text-white max-w-2xl mr-8 lg:mr-16">
          <h1 className="font-elegant text-5xl md:text-7xl font-bold mb-6 leading-tight drop-shadow-2xl">
            <span className="text-red-600">M</span>arco <span className="text-red-600">P</span>ombo
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-gray-200 font-light drop-shadow-lg">
            Ilusionista & Stand-up Magic
          </p>
          
          <p className="text-lg mb-10 text-gray-300 leading-relaxed drop-shadow-md">
            Más de 20 años dedicados al arte del entretenimiento e ilusionismo. Una propuesta única que combina técnicas clásicas de magia con stand-up comedy, creando experiencias memorables que estimulan la imaginación y el pensamiento crítico.
          </p>
          
          <div className="flex justify-end">
            <button 
              onClick={scrollToContact}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contacto
            </button>
          </div>

        </div>
      </div>
    </section>
  );
}
